import { render, staticRenderFns } from "./course_settings.vue?vue&type=template&id=17669533&scoped=true&"
import script from "./course_settings.vue?vue&type=script&lang=ts&"
export * from "./course_settings.vue?vue&type=script&lang=ts&"
import style0 from "./course_settings.vue?vue&type=style&index=0&id=17669533&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17669533",
  null
  
)

export default component.exports